module.exports = __webpack_public_path__ + "static/11-6f22551622c7bfeb303d62e1b01f3170.jpeg";